// extracted by mini-css-extract-plugin
export default {"mainLayout":"AppLayoutStyles_mainLayout__SI1vS","layout":"AppLayoutStyles_layout__C4d7U"};